// packages
import { Component, h } from 'preact';

// components
import CandidateRow from './components/CandidateRow';
import Contest from './components/Contest';
import PymChild from './components/PymChild';

// internal
import getJSON from './utils/get-json';
import { determineDistrictTitle } from './election-utils';
import { FLAT_RESULTS_URL } from './endpoints';
import { LENGTH_OF_CHECK_INTERVAL } from './constants';

class App extends Component<{ selectedContests: string[] }, {}> {
  constructor() {
    super();

    this.state = { contests: [] };

    this.fetchData = this.fetchData.bind(this);
  }

  fetchData() {
    const selectedContests = this.props.selectedContests;

    getJSON(FLAT_RESULTS_URL).then(contests => {
      const activeContests = contests.filter(contest => {
        const slug = `${contest.office_slug}${
          contest.division_type === 'statewide' ? '' : `-${contest.district}`
        }`;

        return selectedContests.indexOf(slug) >= 0;
      });

      this.setState({ contests: activeContests }, this.startTimer);
    });
  }

  startTimer() {
    this.timer = window.setTimeout(this.fetchData, LENGTH_OF_CHECK_INTERVAL);
  }

  clearTimer() {
    window.clearTimeout(this.timer);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  render() {
    const { contests } = this.state;

    return (
      <PymChild class="embed">
        {contests.map(contest => (
          <Contest
            key={contest.id}
            contest={contest}
            contestTitle={determineDistrictTitle(contest)}
            tableHeader={CandidateRow.Header}
            renderCandidate={(candidate, { totalVotes }) => (
              <CandidateRow
                key={candidate.id}
                ballotName={candidate.ballot_name}
                candidateId={candidate.id}
                contestIsCalled={contest.is_called}
                isIncumbent={candidate.is_incumbent}
                isWinner={candidate.is_winner}
                party={candidate.party}
                totalVotesInContest={totalVotes}
                votes={candidate.votes}
              />
            )}
          />
        ))}
      </PymChild>
    );
  }
}

export default App;
